export class IntersectionSidebar {
  constructor(parentId, sidebarId, sectionClass) {
    this.el = document.getElementById(parentId)
    if (this.el === null) return

    this.sidebar = this.el.querySelector(`#${sidebarId}`)
    this.sections = [...this.el.getElementsByClassName(sectionClass)]
    if (this.sidebar === null || this.sections.length === 0) return

    const fragment = document.createDocumentFragment()
    this.sidebarItems = []
    this.isClicking = false
    this.isMobile = window.innerWidth <= 768 // スマホ判定

    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (this.isClicking || this.isMobile) return
        entries.forEach(({ isIntersecting, target }) => {
          const index = Number(target.dataset.id)
          if (isIntersecting) {
            this.sidebarItems.forEach((item, i) => {
              item.classList.toggle('is-act', i === index)
            })
            this.scrollSidebar(index)
          }
        })
      },
      {
        root: null,
        rootMargin: '-50% 0%',
        threshold: 0,
      }
    )

    this.sections.forEach((section, index) => {
      section.dataset.id = index
      const listItem = document.createElement('li')
      const anchor = document.createElement('a')
      this.sidebarItems.push(anchor)
      listItem.appendChild(anchor)
      section.id = `intersection-${index}`
      anchor.href = `#intersection-${index}`
      anchor.textContent = section.dataset.title

      if (section.dataset.titleCheck === 'true') {
        listItem.classList.add('u-ml0')
      }

      anchor.addEventListener('click', (e) => {
        e.preventDefault()
        this.isClicking = true
        this.sidebarItems.forEach((item) => item.classList.remove('is-act'))
        anchor.classList.add('is-act')

        if (!this.isMobile) {
          const targetSection = document.getElementById(`intersection-${index}`)
          const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0

          window.scrollTo({
            top: targetSection.offsetTop - headerHeight,
            behavior: 'smooth',
          })

          this.scrollSidebar(index)
        }

        setTimeout(() => {
          this.isClicking = false
        }, 800)
      })

      fragment.appendChild(listItem)
      intersectionObserver.observe(section)
    })

    this.sidebar.appendChild(fragment)
  }

  scrollSidebar(index) {
    if (this.isMobile) return // スマホなら処理しない
    const activeItem = this.sidebarItems[index]
    if (activeItem) {
      activeItem.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    }
  }
}
